import { useEffect, useState } from "react";

import fetch from "cross-fetch";

import { useAnalytics } from "../../components";
import { UiStatuspageModel } from "../../models";

import { Link } from "./UiStatuspage.styles";

export type UiStatuspageProps = {
    model: UiStatuspageModel;
    status?: "none" | "minor" | "major" | "critical";
};

async function fetchStatus(
    statuspageId: string
): Promise<"none" | "minor" | "major" | "critical"> {
    const apiUrl = `https://${statuspageId}.statuspage.io/api/v2/status.json`;
    const response = await fetch(apiUrl);
    const content = await response.json();
    return content.status.indicator;
}

const UiStatuspage = ({ model, status }: UiStatuspageProps) => {
    const { sendTrackEvent } = useAnalytics();
    const [indicator, setIndicator] = useState<
        "none" | "minor" | "major" | "critical" | undefined
    >(status);
    const { statuspageId, url } = model.content;

    useEffect(() => {
        //local variable to prevent memory leak
        let isCancelled = false;
        if (!status) {
            //get current status from statuspage
            fetchStatus(statuspageId)
                .then((fetchedIndicator) => {
                    if (!isCancelled) {
                        setIndicator(fetchedIndicator);
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        }

        return () => {
            isCancelled = true;
        };
    }, [status, statuspageId]);

    return indicator ? (
        <Link
            indicator={indicator}
            href={url}
            target="_blank"
            onClick={() => {
                sendTrackEvent("clickedUiStatuspage", {
                    event: "clicked",
                    eventComponent: model.type,
                    eventContainer: "uiColumn",
                    label: model.content[indicator],
                    labelEnglish: indicator,
                    uuid: model.id,
                    href: url
                });
            }}
            data-uuid={model.id}
        >
            <span>{model.content[indicator]}</span>
        </Link>
    ) : null;
};

export default UiStatuspage;
